const orderMapper = {
	ascend: 1,
	descend: -1
};

export const parseSorters = sortInfo => {
	let cleanSortInfo: any = undefined;
	if (typeof sortInfo === 'object' && sortInfo.column)
		cleanSortInfo = { [sortInfo.field]: orderMapper[sortInfo.order] };

	if (Array.isArray(sortInfo))
		sortInfo.forEach(el => {
			if (Array.isArray(el.field))
				cleanSortInfo = { ...cleanSortInfo, [el.field.join('_')]: orderMapper[el.order] };
			else cleanSortInfo = { ...cleanSortInfo, [el.field]: orderMapper[el.order] };
		});
	return cleanSortInfo;
};
